import { render, staticRenderFns } from "./DiscountForCard.vue?vue&type=template&id=d8937eea&scoped=true"
import script from "./DiscountForCard.vue?vue&type=script&lang=js"
export * from "./DiscountForCard.vue?vue&type=script&lang=js"
import style0 from "./DiscountForCard.vue?vue&type=style&index=0&id=d8937eea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8937eea",
  null
  
)

export default component.exports